module.exports = __webpack_public_path__ + "static/mapLocation1-f65999e4aac10ec0b7a2393e6aa48084.png";